import { saveAs } from 'file-saver';
import { Workbook, Worksheet } from "exceljs";
import header from "../Header";
import { ConfigTable, generaTabla } from "../generateTable";
import { styles as sg } from "../styles";
import { Archivo } from '../../../../types/filemanager/Archivo';
import { getFileNameFromSrc } from '../../../../libs/formats';
import { Usuario } from '../../../../types/admin-usuarios/Usuario';

export default async function Archivos(data: Archivo[]){
    const workbook = new Workbook();
    const sheet = header(workbook, "Archivos", 6);

    let row = 3;
    if(true){
        const modifiedData = data.map(item => {
            const fileName = getFileNameFromSrc(item.src);
            return { ...item, name: fileName };
        });
        const configA: ConfigTable = {
            columns: [
                {
                    data: "name", 
                    title: "Nombre del archivo",
                    width: 40
                },
                { data: null, title: "Propietario", width: 30, render: (data:Archivo)=>{return data.propietary? (data.propietary as Usuario).fullname : "Sin propietario"}},
                { data: "tag", title: "Tipo", width: 20, align: "tCenter" },
                { data: "folder.name", title: "Folder", width: 30 },
                {
                    data: "src",
                    title: "Ruta",
                    width: 60,
                    align: "tCenter",
                },
                { data: "createdAt", title: "Fecha", width: 20, align: "tCenter", format: "date" },
            ]
        }

        const archivos = modifiedData;
        vtCabecera(sheet, row, "Reporte de archivos");
        row = generaTabla(archivos, configA, sheet, row + 2);
    }

    const buf = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buf]), `Archivos-${new Date().getFullYear()}.xlsx`);
}

function vtCabecera(sheet: Worksheet, row: number, title: string){
    sheet.mergeCells(row, 1, row, 4);
    const cellA = sheet.getRow(row).getCell(1);
    cellA.value = title;
    cellA.font = sg.font.tBold;
    cellA.alignment = sg.alignment.tCenter;
}
